import { Component, inject, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core'
import { ShopperEstimateService } from '@mmx/shared'

@Component({
  selector: 'mmx-shopper-patient-form',
  templateUrl: './shopper-patient-form.component.html',
  standalone: false,
})
export class ShopperPatientFormComponent implements OnChanges, OnDestroy {
  @Input() readonly = false

  private readonly shopperEstimateService = inject(ShopperEstimateService)

  get form() {
    return this.shopperEstimateService.shopperForm
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['readonly']) {
      if (this.readonly) {
        this.form.disable({ emitEvent: false })
      } else {
        this.form.enable({ emitEvent: false })
      }
    }
  }

  ngOnDestroy() {
    this.form.enable({ emitEvent: false })
  }
}
